/**
 * English - `pricingPlans`: the Pricing plans screen - memberships, packages
 * and plans the storefront's pricing section draws as cards. They belong to
 * the store, not to a theme.
 */
const pricingPlans: Record<string, string> = {
  title: 'Pricing plans',
  intro:
    "Memberships, packages and plans you offer. Active plans appear as cards in your storefront's pricing section, in this order. They are kept when you switch themes.",
  add: 'Add plan',
  loading: 'Loading…',
  load_error: 'This list could not be loaded. Please refresh the page.',
  empty_title: 'No plans yet',
  empty_description: 'Add the first plan customers can choose - a name and a price is enough to start.',
  read_only: 'You can view this list but not change it.',
  visible: 'Shown',
  hidden: 'Hidden',
  featured: 'Highlighted',
  no_price: 'No price shown',
  feature_count_one: '{count} feature',
  feature_count_other: '{count} features',
  books: 'Books: {service}',
  sells: 'Opens: {product}',
  move_up: 'Move up',
  move_down: 'Move down',
  edit: 'Edit',
  delete: 'Delete',
  delete_title: 'Delete plan',
  delete_confirm: 'Delete {name}? It disappears from your storefront. This cannot be undone.',
  saved: 'Saved.',
  deleted: 'Deleted.',
  generic_error: 'That did not save. Please try again.',

  'form.add_title': 'Add plan',
  'form.edit_title': 'Edit plan',
  'form.name': 'Name',
  'form.name_placeholder': 'Gold membership',
  'form.price': 'Price',
  'form.price_placeholder': '₹999',
  'form.period': 'Period',
  'form.period_placeholder': '/month',
  'form.description': 'Description',
  'form.features': 'Features',
  'form.features_hint': 'One per line. Each shows with a tick on the card.',
  'form.features_placeholder': 'Unlimited classes\nFree personal assessment',
  'form.badge': 'Badge',
  'form.badge_placeholder': 'Most popular',
  'form.note': 'Small print',
  'form.note_placeholder': 'Billed yearly',
  'form.featured': 'Highlight this plan',
  'form.featured_hint': 'Drawn in your primary colour with a solid button, so it stands out from the others.',
  'form.button': 'Button',
  'form.button_hint':
    'What the card\'s button does: book a service if one is chosen, otherwise open a product, otherwise follow the link.',
  'form.cta_label': 'Button text',
  'form.cta_label_placeholder': 'Choose plan',
  'form.service': 'Books a service',
  'form.service_hint': 'The button opens the booking form for this service.',
  'form.service_none': 'No service',
  'form.service_hidden': '{name} (hidden)',
  'form.service_missing': '{name} (no longer a service)',
  'form.product': 'Opens a product',
  'form.product_placeholder': 'Search by name or type a product slug',
  'form.product_hint': 'Optional. The button opens this product, where it is bought like any other.',
  'form.product_chosen': 'Opens: {name}',
  'form.href': 'Link',
  'form.href_hint': 'Where the button goes. Leave empty for your products page.',
  'form.href_service_hint': 'Leave empty to open your Book page on the service.',
  'form.href_product_hint': 'Not used while a product is linked - the button opens that product.',
  'form.href_placeholder': '/contact',
  'form.is_active': 'Show on the storefront',
  'form.cancel': 'Cancel',
  'form.save': 'Save',
  'form.saving': 'Saving…',

  'errors.required': 'This field is required.',
  'sells_package': 'Sells package: {package}',
  'package_unknown': 'a deleted package',
  'form.package': 'Sells package',
  'form.package_hint': 'The button lets a logged-in customer buy this package.',
  'form.package_none': 'No package',
  'form.package_missing': 'A deleted package',
};

export default pricingPlans;
